export default __webpack_public_path__ + "static/media/ModularActive.378ca6dd.svg";